import { createSelector } from 'reselect';
import get from 'lodash/get';

import * as AppContext from 'lib/app-context';

const readProp = (slice, key, defaultValue) => {
  if (!slice) {
    return defaultValue;
  }
  if (typeof slice.get === 'function') {
    const val = slice.get(key);
    return val !== undefined ? val : defaultValue;
  }
  return get(slice, key, defaultValue);
};

export const getModalState = state => get(state, 'modal', null);

export const getDisplayModal = createSelector(
  [getModalState],
  modal => Boolean(readProp(modal, 'displayModal', false)),
);

export const getModalHeader = createSelector(
  [getModalState],
  modal => readProp(modal, 'header', null),
);

export const getModalBody = createSelector(
  [getModalState],
  modal => readProp(modal, 'body', null),
);

export const getModalFooter = createSelector(
  [getModalState],
  modal => readProp(modal, 'footer', null),
);

export const getModalHeaderProps = createSelector(
  [getModalState],
  modal => readProp(modal, 'headerProps', {}),
);

export const getModalBodyProps = createSelector(
  [getModalState],
  modal => readProp(modal, 'bodyProps', {}),
);

export const getModalFooterProps = createSelector(
  [getModalState],
  modal => readProp(modal, 'footerProps', {}),
);

export const getModalAppContext = createSelector(
  [getModalState],
  modal => readProp(modal, 'appContext', AppContext.DESKTOP),
);
